// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabbar[data-v-407c8391] {\n  width: 100vw;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  border-top: 0.267vw solid #f5f5f5;\n}", ""]);
// Exports
module.exports = exports;
